import { render, staticRenderFns } from "./StmtLnTypeRelHelplist.vue?vue&type=template&id=468236f8&"
import script from "./StmtLnTypeRelHelplist.vue?vue&type=script&lang=js&"
export * from "./StmtLnTypeRelHelplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports